import { ChangeDetectionStrategy, Component, effect, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { useFavorites } from '../../composables/use-favorites';
import { FavoriteItemComponent } from '../favorite-item/favorite-item.component';

@Component({
    selector: 'app-favorite-list',
    imports: [TranslatePipe, FavoriteItemComponent],
    templateUrl: './favorite-list.component.html',
    styleUrl: './favorite-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoriteListComponent {
    protected readonly vm = useFavorites().vm;
    protected readonly editMode = signal(false);
    protected readonly skeletonRows = [0, 1, 2];

    constructor() {
        effect(() => {
            if (this.vm()?.favoriteSites.length === 0) {
                this.editMode.set(false);
            }
        });
    }
}
